import * as React from 'react';
import { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styles from './Navbar.module.scss';
//components
import { MobileNavbar } from './MobileNavbar';
import { TipsterSidebarConnected } from './TipsterSidebar';
import { UserNavbar } from './UserNavbar';
import { UnloggedUserNavbar } from './UnloggedUserNavbar';
//assets
import SVG from 'react-inlinesvg';
import logoB from '../../assets/logo-black-bg.svg';
import { OldTipPublishPopupConnected } from '../TipPublish/TipPublishPopup/OldTipPublishPopup';
import { useFeatureFlagContext } from '../__providers__/FeatureFlagsContext';

export interface NavbarProps {
  userImg: string;
  requestLogout: () => void;
  isTipster: boolean;
  user: any;
}

export const NavbarComponent: React.FC<NavbarProps & RouteComponentProps> = (
  props,
) => {
  const { user, isTipster, userImg, requestLogout } = props;
  const IS_HIDDEN_LOCATIONS: string[] = [
    //'/pc'
  ];
  const IS_HIDDEN_ON_MOBILE_LOCATIONS: string[] = ['/betPublish'];
  const SHOW_LOGO_LOCATIONS: string[] = [];
  const path = props.location.pathname;
  const isHiddenLocation = IS_HIDDEN_LOCATIONS.some((substring) =>
    path.includes(substring),
  );
  const isHiddenOnMobileLocation = IS_HIDDEN_ON_MOBILE_LOCATIONS.some(
    (substring) => path.includes(substring),
  );
  const showLogoLocation = SHOW_LOGO_LOCATIONS.some((substring) =>
    path.includes(substring),
  );
  const purchaseTipLocation = props.location.pathname.includes('/tips/');
  const purchasePremiumLocation = props.location.pathname.includes('/premium/');
  const { isEnabled } = useFeatureFlagContext();

  useEffect(() => {
    if (purchaseTipLocation) {
      props.location.state = props.location.pathname;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //TODO: delete after permanent flag enable
  const isChannelsFlagEnabled = isEnabled('channel_based_tips_publishing');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* LOGGED OUT */}
      {!user &&
        !isHiddenLocation &&
        (purchaseTipLocation || purchasePremiumLocation) && (
          <UnloggedUserNavbar />
        )}
      {/* LOGGED IN */}
      {user && !isHiddenLocation ? (
        <>
          {/* DESKTOP */}

          <div className={styles.desktop}>
            {isTipster ? (
              <div className={styles.tipsterSidebarWrapper}>
                <TipsterSidebarConnected
                  userImg={userImg}
                  requestLogout={requestLogout}
                  user={user}
                  //TODO: delete after permanent flag enable
                  setIsOpen={setIsOpen}
                  isOpen={isOpen}
                />
              </div>
            ) : (
              <UserNavbar
                userImg={userImg}
                requestLogout={requestLogout}
              ></UserNavbar>
            )}
          </div>

          {/* MOBILE */}
          {!isHiddenOnMobileLocation && (
            <div className={styles.mobile}>
              <MobileNavbar
                requestLogout={requestLogout}
                isTipster={isTipster}
                user={user}
              ></MobileNavbar>
            </div>
          )}
          {/* POPUP */}
          {!isChannelsFlagEnabled && isOpen && (
            <OldTipPublishPopupConnected
              onClose={() => setIsOpen(false)}
            ></OldTipPublishPopupConnected>
          )}
        </>
      ) : showLogoLocation ? (
        <div className={styles.logo}>
          <SVG src={logoB} />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export const Navbar = withRouter(NavbarComponent);
